export const raskid_ugovora_o_radu_sporazum_1 = {
  templateId: 17.1,
  category: 11,
  templateTitle: "Sporazum o raskidu ugovora o radu",
  templateDescription: `Kao i svaka druga vrsta ugovora, i ugovor o radu može prestati suglasnošću volja ugovornih strana - sporazumom, na način da poslodavac i radnik u navedenom sporazumu uređuju međusobna prava i obveze te sporazumno određuju dan prestanka radnog odnosa.`,
  description: `
    <h5>OPIS DOKUMENTA</h5>
    <p>Raskid radnog odnosa na temelju sporazuma jedan je od načina prestanka radnog odnosa. </p>
    <p>Sporazum o prestanku ugovora o radu mora biti sklopljen u pisanom obliku. </p>
    <p>Ponuda/prijedlog za prestanak ugovora o radu može biti upućena od radnika, ali i od poslodavca. </p>
    <p><strong>Ukoliko je radni odnos prestao sporazumom, radnik nema pravo na novčanu naknadu s Hrvatskog zavoda zapošljavanje. </strong></p>
    <h5>SVRHA DOKUMENTA</h5>
    <p>Navedenim sporazumom utvrđuje se rok/datum prestanka radnog odnosa te sva međusobna prava i obveze (potraživanja i sl.) između poslodavca i radnika. </p>
    <h5>PRAVNA OSNOVA</h5>
    <p>Zakon o radu, Pravilnik o radu.</p>
  `,
  
  sides: [
  {
    prefix: "Na temelju odredaba Zakona o radu i Pravilnika o radu,",
    signature: "Za Poslodavca:",
    inputs: [{
      type: "input",
      required: true,
      placeholder: "Poslovni subjekt",
    },
    {
      type: "input",
      required: true,
      placeholder: "Ulica i kućni broj",
    },
    {
      type: "input",
      required: true,
      placeholder: "Mjesto",
    },
    {
      type: "input",
      required: true,
      placeholder: "OIB",
    },
    {
      type: "input",
      placeholder: "Zastupa",
      inSignature: true,
    },
    {
      type: "input",
      placeholder: "Funkcija",
      inSignature: true,
    }],
    suffix: " (u daljnjem tekstu: Poslodavac)",
    delimiter: `i`
  },
  {
    signature: "Radnik:",
  	inputs:[{ 
      type: "input", 
      required: true, 
      placeholder: "Ime i prezime",
      label: "Ime i prezime",
      inSignature: true,
    },
    { 
      type: "input", 
      required: true, 
      placeholder: "Ulica i kućni broj",
    },
    { 
      type: "input", 
      required: true, 
      placeholder: "Mjesto",
    },
    { 
      type: "input", 
      required: true, 
      placeholder: "OIB",
    },
    ],
    suffix: " (u daljnjem tekstu: Radnik),"
  }
  ],
  
  headline: "zaključuju sljedeći",
  title: "SPORAZUM O PRESTANKU UGOVORA O RADU",

  articles: [
  {
    title: "DATUM SKLAPANJA UGOVORA O RADU",
    mandatory: true,
    statements: [
    {
      type: "input",
      mandatory: true,
      editable: false,
      parts: [
        { type: "text", content: "Ugovor o radu između Poslodavca i Radnika sklopljen je dana " },
        { type: "input",  required: true },
        { type: "text", content: "godine." },
      ],
      value:"",
    },
    ]
  },
  {
    title: "INICIRANJE SPORAZUMNOG PRESTANKA",
    mandatory: false,
    statements: [
    {
      type: "choice",
      mandatory: true,
      editable: true,
      choices: [
        "Sporazumne stranke suglasne su da je Radnik Poslodavcu uputio usmeni zahtjev za sporazumni prestanak Ugovora o radu kojemu Poslodavac udovoljava te sklapaju ovaj Sporazum na zahtjev Radnika.",
        "Sporazumne stranke suglasne su da Poslodavac Radniku uputio usmeni zahtjev za sporazumni prestanak Ugovora o radu kojemu Radnik udovoljava te sklapaju ovaj Sporazum na zahtjev Poslodavca.",
      ],
      placeholder: "Odaberite ovdje te potom izmijenite po želji...",
    },
    ]
  },
  {
    title: "DATUM PRESTANKA UGOVORA O RADU",
    mandatory: true,
    statements: [
    {
      type: "input",
      mandatory: true,
      editable: false,
      parts: [
        { type: "text", content: "Radni odnos naveden u ovom Sporazumu prestaje suglasnošću volja stranaka dana" },
        { type: "input",  required: true },
        { type: "text", content: " godine." },
      ],
      value:"",
    },
    ]
  },
  {
    title: "POTRAŽIVANJA RADNIKA NA IME PLAĆE",
    mandatory: false,
    statements: [
    {
      type: "text",
      mandatory: true,
      editable: true,
      content: "Do prestanka ugovora o radu Radnik ima pravo na plaću u iznosu određenom ugovorom o radu."
    },
    ]
  },
  {
    title: "PREOSTALA POTRAŽIVANJA",
    mandatory: false,
    statements: [
    {
      type: "choice",
      mandatory: true,
      editable: false,
      choices: [
      {
        parts: [
        { type: "text", content: "Radnik ima potraživanje prema Poslodavcu na ime prava na godišnji odmor, a koji će koristiti u cijelosti u periodu od "},
        { type: "input", value: "", required: true },
        { type: "text", content: "godine do"},
        { type: "input", value: "", required: true },
        { type: "text", content: " godine."},
        { type: "text", content: "Osim potraživanja na ime plaće i potraživanja iz ovog članka, stranke Sporazuma suglasno utvrđuju da jedna prema drugoj nemaju nikakvih međusobnih potraživanja po bilo kojoj osnovi koja bi proizlazila iz radnog odnosa zasnovanog Ugovorom o radu navedenom u ovom Sporazumu."}
        ]
      },
      {
        parts: [
        { type: "text", content: "Radnik ima potraživanje prema Poslodavcu na ime prava na godišnji odmor, a koji će uslijed nemogućnosti korištenja godišnjeg odmora Poslodavac Radniku isplatiti kao naknadu za neiskorišteni godišnji odmor."},
        { type: "text", content: "Osim potraživanja na ime plaće i potraživanja iz ovog članka, stranke Sporazuma suglasno utvrđuju da jedna prema drugoj nemaju nikakvih međusobnih potraživanja po bilo kojoj osnovi koja bi proizlazila iz radnog odnosa zasnovanog Ugovorom o radu navedenom u ovom Sporazumu."},
        ]
      },
      {
        parts: [
        { type: "text", content: "Radnik ima potraživanje prema Poslodavcu na ime prava na godišnji odmor koji će koristiti djelomično u periodu od "},
        { type: "input", value: "", required: true },
        { type: "text", content: "godine do"},
        { type: "input", value: "", required: true },
        { type: "text", content: " godine, dok će uslijed nemogućnosti korištenja preostalog dijela godišnjeg odmora Poslodavac Radniku isplatiti kao naknadu za neiskorišteni godišnji odmor."},
        { type: "text", content: "Osim potraživanja na ime plaće i potraživanja iz ovog članka, stranke Sporazuma suglasno utvrđuju da jedna prema drugoj nemaju nikakvih međusobnih potraživanja po bilo kojoj osnovi koja bi proizlazila iz radnog odnosa zasnovanog Ugovorom o radu navedenom u ovom Sporazumu."}
        ]
      },
      {
        parts: [
        { type: "text", content: "Poslodavac ima prema Radniku potraživanje na ime "},
        { type: "input", value: "", required: true },
        { type: "text", content: ", koje se Radnik obvezuje isplatiti Poslodavcu u do "},
        { type: "input", value: "", required: true },
        { type: "text", content: "Osim potraživanja na ime plaće i potraživanja iz ovog članka, stranke Sporazuma suglasno utvrđuju da jedna prema drugoj nemaju nikakvih međusobnih potraživanja po bilo kojoj osnovi koja bi proizlazila iz radnog odnosa zasnovanog Ugovorom o radu navedenom u ovom Sporazumu."}
        ]
      },
      ],
    },
    ]
  },
  {
    title: 'PRIMJERCI SPORAZUMA',
    mandatory: false,
    statements: [
        {
            type: 'text',
            required: false,
            mandatory: true,
            editable: true,
            content: 'Ovaj Sporazum sastavljen je u 2 (dva) primjerka, od kojih svaka strana Sporazuma zadržava po 1 (jedan) primjerak.',
            value: '',
        }],
  },
{
  mandatory: true,
  static: true,
  type: 2, // date and place
  statements: [
    {
      type: "input",
      mandatory: true,
      parts: [
        {
          type: "text",
          content: "U"
        },
        {
          type: "input",
          value: "",
          placeholder: "Upišite mjesto.",
          required: true,
        },
        {
          type: "text",
          content: ", dana"
        },
        {
          type: "date",
          value: new Date(),
          required: true
        },
        {
          type: "text",
          content: "godine."
        }
      ]
    },
  ]
},
    {
      mandatory: true,
      static: true,
      type: 3,  // signatures
      statements: [],
    }
  ],
};


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/17.1_raskid_ugovora_o_radu_sporazum.1.ts